import React, { useState, useCallback, ChangeEvent, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Dictionary } from 'lodash';
import { DeviceStatus } from 'ui/shared/deviceStatus';

export type Props = {
    selectedDeviceStatuses: Dictionary<boolean>;
    onChange(fn: (deviceStatuses: Dictionary<boolean>) => Dictionary<boolean>): void;
};

export const DeviceStatusFilter = ({ selectedDeviceStatuses, onChange }: Props) => {
    const { t } = useTranslation();

    const deviceStatuses = useMemo(() => {
        return [
            { value: 'UP', text: t('DEVICES.STATUS.UP') },
            { value: 'L1', text: t('DEVICES.STATUS.LATE1') },
            { value: 'L2', text: t('DEVICES.STATUS.LATE2') },
            { value: 'DN', text: t('DEVICES.STATUS.DOWN') },
            { value: '--', text: t('DEVICES.STATUS.OFFLINE') },
        ];
    }, [ t ]);

    const [ collapsed, setCollapsed ] = useState(false);

    const handleClickCheckbox = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        const { id } = e.currentTarget.dataset;
        onChange(dt => ({
            ...dt,
            [id!]: !dt[id!],
        }));
    }, [ onChange ]);
    
    const handleClickHeader = useCallback(() => {
        setCollapsed(c => !c);
    }, [ setCollapsed ]);

    return (
        <div
            id="device-status-filter"
            className={ `device-filter ${collapsed ? 'collapsed' : ''}` }
        >
            <header
                onClick={ handleClickHeader }
            >
                <i className="ui down triangle icon"/>
                <span>
                    { t('DEVICES.FILTERS.DEVICE_STATUS') }
                </span>
            </header>
            { !collapsed &&
                <ul>
                    { deviceStatuses.map(({ value, text }) =>
                        <li
                            key={ value }
                        >
                            <label>
                                <input
                                    type="checkbox"
                                    data-id={ value }
                                    checked={ !!selectedDeviceStatuses[value] }
                                    onChange={ handleClickCheckbox }
                                />
                                <DeviceStatus status={ value }/>
                                <span>
                                    { text }
                                </span>
                            </label>
                        </li>
                    ) }
                </ul>
            }
        </div>
    );
};
